import { render, staticRenderFns } from "./FilterChipButtons.vue?vue&type=template&id=1be465b6&"
import script from "./FilterChipButtons.vue?vue&type=script&lang=js&"
export * from "./FilterChipButtons.vue?vue&type=script&lang=js&"
import style0 from "./FilterChipButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
